import React from 'react';
import PropTypes from 'prop-types';
// import styled from 'styled-components';
import { Button } from 'semantic-ui-react';
import { Link } from 'react-router-dom';

// eslint-disable-next-line
const CTA = ({ children, external, link, flex, ...rest }) => {
  const isExternal = external || link.startsWith('http');

  const ctaProps =
    link && isExternal
      ? { as: 'a', href: link, target: '_blank' }
      : { as: Link, to: link };

  return (
    <Button
      secondary
      size="small"
      {...ctaProps}
      {...rest}
      className={flex ? 'flex' : ''}
    >
      {children}
    </Button>
  );
};

CTA.propTypes = {
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  external: PropTypes.bool,
  link: PropTypes.string,
  flex: PropTypes.bool
};
export default CTA;



// WEBPACK FOOTER //
// ./src/components/CTA.js